import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { openModal } from 'actions/modal';
import { confirmLeavePage } from 'actions/app';
import { connect } from 'react-redux';
import { logoutUser } from 'actions/user';
import { StoreProps } from 'store';
import { WithRouterProps } from 'decorators/withRouter';
import { addTranslation, IntlProps } from 'decorators/addTranslation';
import RoundButton from 'components/ui/roundButton';
import './logout.scss';

interface ConnectedProps {
  isConfirmLogout: boolean;
}

interface OwnProps {
  customClass?: string;
}

class Logout extends PureComponent<
  StoreProps & WithRouterProps & OwnProps & ConnectedProps & IntlProps
> {
  render() {
    return (
      <RoundButton
        size={30}
        iconSize={14}
        onClick={this.onLogout}
        icon='im-Log-out'
        status='none'
        customClass='logout'
      />
    );
  }

  onLogout = () => {
    const { isConfirmLogout, dispatch } = this.props;

    if (isConfirmLogout) {
      dispatch(
        openModal({
          modalId: 'Confirm',
          content: {
            title: 'projects.urls.modal.urlChangeDiscard.header',
            text: 'projects.urls.modal.urlChangeDiscard.label',
          },
          callback: (isContinue) => {
            dispatch(confirmLeavePage({ isConfirm: !isContinue }));
            if (isContinue) {
              this.logout();
            }
          },
        })
      );
    } else {
      this.logout();
    }
  };

  logout = () => {
    this.props.dispatch(
      logoutUser(() => {
        this.props.history.replace('/login', {});
      })
    );
  };
}

const mapStateToProps = (state) => ({
  isConfirmLogout: state.app.isConfirm,
});

export default connect(mapStateToProps)(withRouter(addTranslation(Logout)));
